import { render, staticRenderFns } from "./SiniestroAccidentes.vue?vue&type=template&id=34ab6844&scoped=true&"
import script from "./SiniestroAccidentes.vue?vue&type=script&lang=js&"
export * from "./SiniestroAccidentes.vue?vue&type=script&lang=js&"
import style0 from "./SiniestroAccidentes.vue?vue&type=style&index=0&id=34ab6844&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ab6844",
  null
  
)

export default component.exports